export class OzNocReplyMailPeopleGroup{
    constructor(){
        this.ci_no = null;
        this.name = null;
        this.class_no = null;
        this.custom_field = null;
    }
}